@if (gamesFilter.state().isShowFiltersBar) {
  <form [ngClass]="{'gradient-filter': isFirefox, 'card-gradient' : !isFirefox}" (ngSubmit)="onSubmit()"
        [formGroup]="isGamesFilterBarSideNav() ? gamesFilter.state().filtersFormSideNav : gamesFilter.state().filtersForm">
    <div class="filters-container">
      <div class="filters-container__categories">
        <div class="filters-container__title">{{ 'link.categories' | translate }}</div>
        <app-multi-checkbox
          formControlName="category_in[]"
          [withGrid]="true"
          [options]="gamesFilter.state().categoriesOptions">
        </app-multi-checkbox>
      </div>
      <div class="filters-container__providers">
        <div class="filters-container__title">{{ 'link.providers' | translate }}</div>
        <app-multi-checkbox
          formControlName="provider[]"
          [withGrid]="true"
          [options]="gamesFilter.state()?.providersOptions"
          [availableOptions]="gamesFilter.state()?.availableProviders"
          [loading]="gamesFilter.state()?.isLoadingProvider"
        >
        </app-multi-checkbox>
      </div>
      <div class="filters-container__actions">
        <button (click)="onCancel()" class="btn small" type="button">{{ 'btn.cancel' | translate }}</button>
        <button class="btn small" type="submit">{{ 't.apply' | translate }}</button>
      </div>
    </div>
  </form>
}
